module.exports = __webpack_public_path__ + "static/media/user-05.479f00d1.jpg";